import { FormInstance } from "antd";
import React from "react";
import { useFetcher } from "react-router-dom";
import { INTENTS } from "~/utils";

const useCreateOrganizationPage = ({
  formInstance,
}: {
  formInstance: FormInstance<any>;
}) => {
  const [isPopUpOpen, setIsPopUpOpen] = React.useState(false);
  const [intent, setIntent] = React.useState(INTENTS._create_organization);
  const fetcher = useFetcher();
  const isLoading = fetcher.state !== "idle";
  const togglePopUpConfirm = () => {
    setIsPopUpOpen(!isPopUpOpen);
  };

  const handlePopUpSubmit = (intent: string) => {
    setIntent(intent);
    formInstance.submit();
    togglePopUpConfirm();
  };

  const handleSubmit = async (formData: {
    name: string;
    transferProperties: boolean;
    requestTransferProperties: boolean;
    code: string;
  }) => {
    console.log("formData", formData);
    fetcher.submit(
      { body: JSON.stringify(formData), intent },
      { method: "post" }
    );
  };

  return {
    isPopUpOpen,
    togglePopUpConfirm,
    handleSubmit,
    handlePopUpSubmit,
    isLoading,
  };
};

export default useCreateOrganizationPage;
